export default {
  "content": "<path d=\"M12 15a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM13 13.5h-2V9h2v4.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2a1 1 0 01.857.485l10.5 17.5A1.001 1.001 0 0122.5 21.5h-21a1 1 0 01-.857-1.515l10.5-17.5.074-.107A1 1 0 0112 2zM3.267 19.5h17.466L12 4.943 3.267 19.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};